import React, {useState, useEffect} from 'react';

const ColorField = ({id, label, placeholder, helpBlock, valueOnChoose, value, onChange}) => {

  const [_value, setValue] = useState(value);

  useEffect(() => setValue(value), [value]);
  useEffect(() => onChange(_value), [_value]);

  const button = (label, onClick) => <button type="button" className="btn btn-outline-dark"
                                             onClick={() => onClick()}>
    {label}
  </button>;

  return <div className="mb-3">
    {label && <label htmlFor={id} className="form-label">{label}</label>}
    <div className="input-group">
      {_value ?
        button('Clear color', () => setValue(null)) :
        button('Choose color', () => setValue(valueOnChoose || '#000000'))
      }
      {_value &&
        <input type="color"
               id={id}
               className="form-control form-control-color"
               style={{maxWidth: '100%'}}
               placeholder={placeholder}
               value={_value}
               onChange={e => setValue(e.target.value)}/>
      }
    </div>
    {helpBlock && <div className="form-text">{helpBlock}</div>}
  </div>
};

export default ColorField;
